import dayjs from "dayjs"

export function oldestDate(date1: string, date2: string) {
  if (dayjs(date2).isBefore(date1)) {
    return date2
  }

  return date1
}
